"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeywordSearch = void 0;
const GQLQueryArrayHook_1 = __importDefault(require("@opsbase/react-gql/GQLQueryArrayHook"));
const GQLResponseType_1 = __importDefault(require("@opsbase/react-gql/GQLResponseType"));
const keywordSearchConfig = {
    name: 'keywordSearch',
    response: GQLResponseType_1.default.ARRAY,
    fields: 'offset, limit, totalCount, type, ' + 'items { id, title, titleAlt, avatarUrl}',
    params: {
        type: '[String]!',
        keyword: 'String',
        offset: 'Int',
        limit: 'Int',
        opDefinition: '[String]',
        staff: '[String]',
        team: '[String]',
        position: '[String]',
        organisation: '[String]',
        place: '[String]',
        tag: '[String]',
        permitAdhoc: '[String]',
        showMineOnly: '[String]',
        showWebAppOnly: '[String]',
        enabled: '[String]',
        parent: '[String]',
        isTreeRoot: 'Boolean',
    },
};
exports.useKeywordSearch = (0, GQLQueryArrayHook_1.default)(keywordSearchConfig);
exports.default = exports.useKeywordSearch;
